import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/member-todo-toolbar';

Component('tr-member-todo-toolbar', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    groupBy: String,
  },

  ready() {
    this.listenTo(this, 'tr-selector-field:change', this.handleChange.bind(this));
  },

  handleChange(event) {
    if (closest(event.target, '.sort-selector')) {
      this.resetGroupSelector();
      this.request({ sort_by: event.detail });
    } else if (closest(event.target, '.group-selector')) {
      this.groupBy = event.detail;
      this.request({ group_by: event.detail });
    } else if (closest(event.target, '.project-selector')) {
      this.url = event.detail;
      window.tower.stack.load(this.url, {
        replace: true,
      });
    }
  },

  resetGroupSelector() {
    const groupSelector = this.querySelector('.group-selector');
    const sortBy = this.querySelector('.sort-selector').getValue();

    if (sortBy === 'sequence') {
      groupSelector.clearSelected();
      groupSelector.disabled = true;
    } else {
      groupSelector.setValue(this.groupBy);
      groupSelector.disabled = false;
    }
  },

  request(params = {}) {
    $.ajax({
      url: this.url,
      type: 'get',
      data: params,
      dataType: 'script',
    });
  },

  disconnected() {
    this.stopListening();
  },
});
